import React, { Component } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Nav from 'react-bootstrap/Nav';

import RegistrationTotalTableV2 from './RegistrationTotalTableV2';
import RegistrationStageTotalChartV2 from './RegistrationStageTotalChartV2';
import RegistrationActiveCardV2 from './RegistrationActiveCardV2';
import RegistrationTotalCardV2 from './RegistrationTotalCardV2';
import RegistrationActiveInactiveChartV2 from './RegistrationActiveInactiveChartV2';
import RegistrationRaceTotalChartV2 from './RegistrationRaceTotalChartV2';
import RegistrationRaceTotalTableV2 from './RegistrationRaceTotalTableV2';
import RegistrationWeeklyTableV2 from './RegistrationWeeklyTableV2';
import RegistrationWeeklyChartV2 from './RegistrationWeeklyChartV2';
import RegistrationProviderChartV2 from './RegistrationProviderChartV2';
import RegistrationProviderTableV2 from './RegistrationProviderTableV2';
import RegistrationRaceTotalChartStackedV2 from './RegistrationRaceTotalChartStackedV2';
import RegistrationWeeklyChartNormalV2 from './RegistrationWeeklyChartNormalV2';
import RegistrationWeeklyChartAreaV2 from './RegistrationWeeklyChartAreaV2';
import RegistrationProviderChartStackedV2 from './RegistrationProviderChartStackedV2';

class RegistrationDashV2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading:true
        };
    }

    componentDidMount(){
        console.log("Mounted");
    }

    render(){
        return(
            <>
                <Row>
                    <Col xs={12} md={12}>
                        <Card>
                            <Row>
                                <Col xs={12} md={12} style={{padding:"10px"}}>
                                    <Nav activeKey="#/demo/registration">
                                        <Nav.Item>
                                            <Nav.Link href="#/cards/registration/total">Card Total</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link href="#/cards/registration/active">Card Active</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link href="#/charts/registration/active">Chart</Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Col>
                                <Col xs={12} sm={12} md={3} style={{padding:"10pt"}}>
                                    <div style={{padding:"10px"}}>
                                        <RegistrationTotalCardV2></RegistrationTotalCardV2>
                                    </div>
                                </Col>
                                <Col xs={12} sm={12} md={3} style={{padding:"10pt"}}>
                                    <div style={{padding:"10px"}}>
                                        <RegistrationActiveCardV2></RegistrationActiveCardV2>    
                                    </div>
                                </Col>
                                <Col xs={12} sm={12} md={6} style={{padding:"10pt"}}>
                                    <div style={{paddingRight:"10px"}}>
                                        <RegistrationActiveInactiveChartV2 height="170px" maxHeight="170px"></RegistrationActiveInactiveChartV2>    
                                    </div>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>

                <Row style={{paddingTop:"15pt"}}>
                    <Col xs={12} md={12}>
                        <Card>
                            <Col xs={12} md={12} style={{padding:"10px"}}>
                                <Nav activeKey="#/demo/registration">
                                    <Nav.Item>
                                        <Nav.Link href="#/charts/registration/stage">Chart</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link href="#/tables/registration/total">Table</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </Col>
                            <Col xs={12} md={12} style={{padding:"10px"}}>
                                <RegistrationStageTotalChartV2 height="200px" maxHeight="200px"></RegistrationStageTotalChartV2>
                            </Col>
                            
                            <Col xs={12} md={12} style={{padding:"10px"}}>
                                <RegistrationTotalTableV2 height="100%"></RegistrationTotalTableV2>
                            </Col>
                        </Card>
                    </Col>
                </Row>
       
                <Row style={{paddingTop:"15pt"}}>
                    <Col xs={12} md={12}>
                        <Card>
                            <Col xs={12} md={12} style={{padding:"10px"}}>
                                <Nav activeKey="#/demo/registration">
                                    <Nav.Item>
                                        <Nav.Link href="#/charts/registration/race">Chart 100%</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link href="#/charts/registration/raceStacked">Chart Stacked</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link href="#/tables/registration/race">Table</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </Col>
                            <Col xs={12} md={12} style={{padding:"10px"}}>
                                <RegistrationRaceTotalChartV2 height="300px" maxHeight="320px"></RegistrationRaceTotalChartV2>
                            </Col>
                            <Col xs={12} md={12} style={{padding:"10px"}}>
                                <RegistrationRaceTotalChartStackedV2 height="300px" maxHeight="300px"></RegistrationRaceTotalChartStackedV2>
                            </Col>
                            <Col xs={12} md={12} style={{padding:"10px"}}>
                                <RegistrationRaceTotalTableV2 height="100%"></RegistrationRaceTotalTableV2>
                            </Col>
                        </Card>
                    </Col>
                </Row>
                
                <Row style={{paddingTop:"15pt"}}>
                    <Col xs={12} md={12}>
                        <Card>
                            <Col xs={12} md={12} style={{padding:"10px"}}>
                                <Nav activeKey="#/demo/registration">
                                    <Nav.Item>
                                        <Nav.Link href="#/charts/registration/weekly">Chart Log</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link href="#/charts/registration/weeklyNormal">Chart Normal</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link href="#/charts/registration/weeklyArea">Chart Area</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link href="#/tables/registration/weekly">Table</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </Col>
                            <Col xs={12} md={12} style={{padding:"10px"}}>
                                <RegistrationWeeklyChartV2 height="400px" maxHeight="400px"></RegistrationWeeklyChartV2>            
                            </Col>
                            <Col xs={12} md={12} style={{padding:"10px"}}>
                                <RegistrationWeeklyChartNormalV2 height="400px" maxHeight="400px"></RegistrationWeeklyChartNormalV2>            
                            </Col>
                            <Col xs={12} md={12} style={{padding:"10px"}}>
                                <RegistrationWeeklyChartAreaV2 height="400px" maxHeight="400px"></RegistrationWeeklyChartAreaV2>            
                            </Col>
                            <Col xs={12} md={12} style={{padding:"10px"}}>
                                <RegistrationWeeklyTableV2 height="100%"></RegistrationWeeklyTableV2>
                            </Col>
                        </Card>
                    </Col>
                    
                </Row>
                
                <Row style={{paddingTop:"15pt"}}>
                    <Col xs={12} md={12}>
                        <Card>
                            <Col xs={12} md={12} style={{padding:"10px"}}>
                                <Nav activeKey="#/demo/registration">
                                    <Nav.Item>
                                        <Nav.Link href="#/charts/registration/provider">Chart 100%</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link href="#/charts/registration/providerStacked">Chart Stacked</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link href="#/tables/registration/provider">Table</Nav.Link>
                                    </Nav.Item>
                                    
                                </Nav>
                            </Col>
                            <Col xs={12} md={12} style={{padding:"10px"}}>
                                <RegistrationProviderChartV2 height="400px" maxHeight="400px"></RegistrationProviderChartV2>            
                            </Col>
                            <Col xs={12} md={12} style={{padding:"10px"}}>
                                <RegistrationProviderChartStackedV2 height="400px" maxHeight="400px"></RegistrationProviderChartStackedV2>            
                            </Col>
                            
                            <Col xs={12} md={12} style={{padding:"10px"}}>
                                <RegistrationProviderTableV2 height="100%"></RegistrationProviderTableV2>           
                            </Col>
                        </Card>
                    </Col>
                </Row>
            
            </>
        )
    }

}

export default RegistrationDashV2;